import Service from "./abstract/Service";
import { default as Obj } from "@/objects/abstract/Object";

export class GoogleGeometry extends Obj {
  location = { lat: null, lng: null };
  location_type;
  viewport = {
    northeast: { lat: null, lng: null },
    southwest: { lat: null, lng: null }
  };

  constructor(props) {
    super();
    this.initializeAttributes(props);
  }
}

export default class GoogleService extends Service {
  findByCity(city) {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({
        address: city,
        region: 'eu'
      }, (results, status) => {
        if (status === "OK") {
          const result = results.find(result => !!result.geometry);
          const geometry = result ? new GoogleGeometry(this.convertGeometry(result.geometry)) : null;
          resolve(geometry);
        }

        reject(status);
      })
    })
  }

  /**
   * Returns address from geolocation
   *
   * @param {Object} latlng { lat: 0, lng: 0 }
   */
  reverseGeocoding(latlng) {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            resolve(results[0]);
          } else {
            reject("No results found");
          }
        } else {
          reject("Geocoder failed due to: " + status);
        }
      });
    })
  }

  convertGeometry(geometry) {
    return {
      location_type: geometry.location_type,
      location: {
        lat: geometry.location.lat(),
        lng: geometry.location.lng()
      },
      viewport: geometry.viewport
    }
  }
}
